import { dataCameraAddSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCameraAddSolid = /*#__PURE__*/createIcon(dataCameraAddSolid)
export default IconCameraAddSolid
